import { render, staticRenderFns } from "./vip-promotion.vue?vue&type=template&id=6ddb57ff&scoped=true&"
import script from "./vip-promotion.vue?vue&type=script&lang=js&"
export * from "./vip-promotion.vue?vue&type=script&lang=js&"
import style0 from "./vip-promotion.vue?vue&type=style&index=0&id=6ddb57ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb57ff",
  null
  
)

export default component.exports